import './styles.scss'
import * as React from 'react'
import { Modal } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { getStaticImage } from 'utils/statics'
import { Button } from 'components/Form'
import { lang } from 'utils/helpers'

const ModalDelete = (props) => {
  const {
    isOpen, toggle, event, header, text1, text2, isSubmitting, errorMessage,
    errorMessageInternationalization = true, className = '', textBtn1, textBtn2
  } = props

  return (
    <Modal id='modal-content-remove' centered isOpen={isOpen} toggle={toggle} className={className} contentClassName={'modal-content-remove'}>
      <div className='modal-wrapper-header'>
        <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' onClick={toggle}/>
      </div>
      <img className='icon-remove' src='img/icons/icon-warning-red.svg' alt='remove' />
      <h1 dangerouslySetInnerHTML={{ __html: header }} />
      <h2 dangerouslySetInnerHTML={{ __html: text1 }} />
      <legend dangerouslySetInnerHTML={{ __html: text2 }} />

      {errorMessage ? (
        <p
          className='error-message'
          dangerouslySetInnerHTML={{
            __html: errorMessageInternationalization ? I18n.t(errorMessage) : errorMessage
          }}
        />
      ) : null}

      <div className='wrapper-buttons'>
        <Button
          secondary={true}
          value={textBtn1 || lang('dashboard_cancel')}
          onClick={toggle}
          className='button-remove'
        />
        {event &&
          <Button
            remove={true}
            value={textBtn2 || lang('dashboard_delete')}
            onClick={event}
            className={'button-remove'}
            isSubmitting={isSubmitting}
          />
        }
      </div>
    </Modal>
  )
}

export default ModalDelete
